import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface AuthLayoutProps {
  children: ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-[420px] animate-fade-in">
        {/* Logo */}
        <div className="flex flex-col items-center mb-8 gap-3">
          <div
            className="inline-flex items-center justify-center w-14 h-14 rounded-2xl"
            style={{ background: 'var(--gradient-primary)' }}
          >
            <span className="text-white text-xl font-bold">SA</span>
          </div>
          <div className="text-center">
            <h1 className="text-lg font-semibold text-foreground">{t('app.name')}</h1>
            <p className="text-xs text-muted-foreground">{t('app.tagline')}</p>
          </div>
        </div>

        {children}
      </div>
    </div>
  );
}
